import State from './state';

export function setProblemList(state, data) {
  state.problem_list = data.data;
}

export function setCauseList(state, data) {
  state.cause_list = data;
}

export function setChangeList(state, data) {
  state.change_list = data;
}

export function setSkillList(state, data) {
  state.skill_list = data;
}

export function setSkillDescription(state, data) {
  state.skill_description = data;
}

export function setConfiguration(state, error) {
  state.error = error;
}

export function setConfigList(state, data) {
  state.config_list = data;
}

export function setTipsList(state, data) {
  state.tips_list = data;
}

export function setSkillTipsList(state, data) {
  state.skill_tips_list = data;
}

export function setInfoPopup(state = State, data) {
  const { problem = {} } = data;
  state.popup.problem = { ...problem };
}

export function setChangesByCategory(state, data) {
  state.changesByCategory = data;
}

export function deleteProblemSaved(state = State, problemId) {
  const problemsSavedFiltered = state.config_list.filter((problem) => problem.id !== problemId);
  state.config_list = [...problemsSavedFiltered];
}

export function cleanErrors(state) {
  state.error = '';
}

export function error(state, error) {
  state.error = error;
}
